import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { FETCH_COLLECTIONS, ResponseCollectionList } from 'modules/collections';
import { State } from 'store/types';
import { KitchenRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/kitchen`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  if ('collectionList' in state.collections) {
    const collectionState = {
      collectionList: state.collections.collectionList,
      offset: state.collections.offset,
      productsCount: state.collections.productsCount,
      facets: state.collections.facets,
    } as ResponseCollectionList;

    store.dispatch(FETCH_COLLECTIONS.success, collectionState);
  }

  return remoteProps => <KitchenRemote router={router} store={store} {...remoteProps} />;
});
